import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { IconComponent, KnowledgeBasePopOver, icon } from "../../../../../../../common/components";
import { translate } from "../../../../../../../common/providers";
import styles from "./PackageCard.module.css";

export default function PackageCard({ pkg, selected, disabled, onSelect }) {
	const language = useSelector(({ context }) => context.language.value);

	const handleClick = () => {
		if (!disabled && onSelect) {
			onSelect(pkg);
		}
	};

	const getLocalizedField = (fieldName) => {
		const desc = pkg?.description;
		if (!desc) {
			return "";
		}
		const descLang = language === "esp" ? "es" : language;
		const langData = desc[descLang] || desc.en || desc.fr || Object.values(desc)[0];
		return langData?.[fieldName] || "";
	};

	const getIcon = () => {
		if (!pkg?.iconSvg) {
			return icon.faDatabase;
		}
		return icon[pkg.iconSvg] || icon.faDatabase;
	};

	const faIcon = getIcon();
	const officialName = getLocalizedField("officialName") || pkg?.name || "";
	const shortDescription = getLocalizedField("shortDescription") || "";
	const hoverDescription = getLocalizedField("hoverDescription") || "";

	return (
		<div
			className={`${styles.card} ${selected ? styles.selected : ""} ${disabled ? styles.disabled : ""}`}
			data-testid="package.btn"
			role="button"
			tabIndex={disabled ? -1 : 0}
			onClick={handleClick}
			onKeyDown={(e) => {
				if (e.key === "Enter" || e.key === " ") {
					handleClick();
				}
			}}
		>
			<div className={styles.topRow}>
				<IconComponent className={styles.icon} icon={faIcon} />
				{hoverDescription && !disabled && (
					<KnowledgeBasePopOver
						color="var(--grey-500)"
						label={<span className={styles.preLineText}>{hoverDescription}</span>}
						size="2xs"
					/>
				)}
				{disabled && (
					<KnowledgeBasePopOver
						color="var(--grey-500)"
						label={translate("dashboards.new-project.package-selection.forced-tooltip")}
						size="2xs"
					/>
				)}
			</div>
			<div className={styles.title} title={officialName}>
				{officialName}
			</div>
			<div className={styles.description} title={shortDescription}>
				{shortDescription}
			</div>
		</div>
	);
}

PackageCard.propTypes = {
	pkg: PropTypes.shape({
		id: PropTypes.number,
		name: PropTypes.string,
		iconSvg: PropTypes.string,
		description: PropTypes.objectOf(
			PropTypes.shape({
				officialName: PropTypes.string,
				shortDescription: PropTypes.string,
				hoverDescription: PropTypes.string,
			})
		),
		forceDisplay: PropTypes.bool,
		isAuthorized: PropTypes.bool,
	}).isRequired,
	selected: PropTypes.bool,
	disabled: PropTypes.bool,
	onSelect: PropTypes.func,
};

PackageCard.defaultProps = {
	selected: false,
	disabled: false,
	onSelect: null,
};
